'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const WarrantyExpiryChart = dynamic(() => import('./WarrantyExpiryChart'), { ssr: false });
const InvoiceUploadChart = dynamic(() => import('./InvoiceUploadChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="space-y-4">
      <div className="bg-card rounded-xl border border-border shadow-card p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600 text-foreground">Warranty Expiry Aging</h3>
            <p className="text-xs text-muted-foreground">Warranties expiring by month</p>
          </div>
          <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded-lg">Next 6 months</span>
        </div>
        <WarrantyExpiryChart />
      </div>
      <div className="bg-card rounded-xl border border-border shadow-card p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600 text-foreground">Invoice Upload Activity</h3>
            <p className="text-xs text-muted-foreground">Invoices captured per week</p>
          </div>
          <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded-lg">Last 8 weeks</span>
        </div>
        <InvoiceUploadChart />
      </div>
    </div>
  );
}